module.exports = __webpack_public_path__ + "img/kioskLogged.9d01a900.png";